import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import LegendLayout from '../../../enums/LegendLayout';

import BubbleControls from './BubbleControls';
import BubbleColorPalette from './BubbleColorPalette';
import BubblePreviewInfo from './BubblePreviewInfo';
import BubbleGraphicsSimplified from './BubbleGraphicsSimplified';

const BubbleSimplified = props => (
    <div className="bubble-legend flex-it column space-between">
        <div className="flex-it space-around grow no-shrink">
            <BubbleGraphicsSimplified bubbleLabel={props.bubbleLabel} />
        </div>
        <BubbleControls
            currentBubbleSizeLog10={props.currentBubbleSizeLog10}
            onBubbleSizeChange={props.onBubbleSizeChange}
        />
        <BubblePreviewInfo maxBubbleLabel={props.maxBubbleLabel} />
        <BubbleColorPalette
            layout={LegendLayout.SIMPLIFIED}
            bubbleValueType={props.bubbleValueType}
            renderer={props.renderer}
            mapInstanceId={props.mapInstance.id}
        />
    </div>
);

BubbleSimplified.propTypes = {
    currentBubbleSizeLog10: PropTypes.number.isRequired,
    bubbleLabel: PropTypes.string.isRequired,
    maxBubbleLabel: PropTypes.string.isRequired,
    renderer: PropTypes.object.isRequired,
    bubbleValueType: PropTypes.string.isRequired,
    onBubbleSizeChange: PropTypes.func.isRequired,
    mapInstance: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(BubbleSimplified);
